import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'block-quote-button',
})
export default class BlockQuoteButton extends IconButton {
}
